import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { FinanceSection } from "@/components/landing/FinanceSection";
import { ActivitiesSection } from "@/components/landing/ActivitiesSection";
import { AnnouncementsSection } from "@/components/landing/AnnouncementsSection";
import { BoardSection } from "@/components/landing/BoardSection";
import { ContactSection } from "@/components/landing/ContactSection";
import { DonorTicker } from "@/components/landing/DonorTicker";
import { DonationSection } from "@/components/landing/DonationSection";

export default function Landing() {
  const [data, setData] = useState({});

  useEffect(() => {
    const load = async () => {
      const [profile, prayer, finance, activities, announcements, board, transactions, donors, donationSettings] = await Promise.allSettled([
        api.get("/profile"),
        api.get("/prayer/today"),
        api.get("/finance/summary"),
        api.get("/activities"),
        api.get("/announcements"),
        api.get("/board"),
        api.get("/transactions?limit=8"),
        api.get("/donations/confirmed"),
        api.get("/donations/public-settings"),
      ]);
      const v = (r) => (r.status === "fulfilled" ? r.value.data : null);
      setData({
        profile: v(profile),
        prayer: v(prayer),
        finance: v(finance),
        activities: v(activities) || [],
        announcements: (v(announcements) || []).filter((a) => a.active),
        board: v(board) || [],
        transactions: v(transactions) || [],
        donors: v(donors) || [],
        donationSettings: v(donationSettings),
      });
    };
    load();
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <Header profile={data.profile} />
      <Hero profile={data.profile} prayer={data.prayer} />
      <DonorTicker donors={data.donors} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-24 py-20">
        <ActivitiesSection activities={data.activities} />
        <AnnouncementsSection announcements={data.announcements} />
        <FinanceSection finance={data.finance} transactions={data.transactions} profile={data.profile} />
        <DonationSection settings={data.donationSettings} />
        <BoardSection board={data.board} />
      </main>
      <ContactSection profile={data.profile} />
    </div>
  );
}
